import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const vivaEngageRebrandingDialog = () =>
  import(/* webpackChunkName: "4-feat-vivaengage-rebranding" */ './VivaEngageRebrandingDialog');

export default lazyLoadOnRender({ loader: vivaEngageRebrandingDialog });
